import ApiService from "./config";

export const Signup = (body: any) => {
    return ApiService.post("user/signup", body);
};
export const Login = (body: any) => {
    return ApiService.post("user/login", body);
};
export const forgot_sendOtp = (body: any) => {
    return ApiService.post("user/forgot_password_sendotp", body);
};
export const forgot_verify = (body: any) => {
    return ApiService.post("user/password_update", body);
};

// ------------GET-Years--------------

export const get_Years = () => {
    return ApiService.get("user/tax_file_years");
};

// -----------BASIC -INFO-------
export const BasicInfo_PersonalInfo_ADD = (body: any) => {
    return ApiService.post(
        `user/postuser/${localStorage.getItem("Year_id")}`,
        body
    );
};
export const BasicInfo_PersonalInfo = () => {
    return ApiService.post(
        `user/get_basicinfo/${localStorage.getItem("Year_id")}`
    );
};
// ----------BASIC DEPENDENT-INFO-----------------

export const BasicInfo_DependentInfo_add = (body: any) => {
    return ApiService.post(
        `/user/add_dependentinfo/${localStorage.getItem("Year_id")}`,
        body
    );
};
export const BasicInfo_DependentInfo_get = () => {
    return ApiService.post(
        `/user/get_dependentinfo/${localStorage.getItem("Year_id")}`
    );
};
export const BasicInfo_DependentInfo_get_details = (infoId: any) => {
    return ApiService.post(`/user/get_dependentinfo_Details/${infoId}`);
};
export const BasicInfo_DependentInfo_update = (
    dependent_id: any,
    body: any
) => {
    return ApiService.put(
        `/user/update_dependentinfo/${dependent_id}?tax_file_year_id=${localStorage.getItem(
            "Year_id"
        )}`,
        body
    );
};

// ----------BASIC BANK-INFO---------
export const BasicInfo_Bank_info_ADD = (body: any) => {
    return ApiService.post(
        `/user/add_bankdetails/${localStorage.getItem(
            "Year_id"
        )}?tax_file_year_id=${localStorage.getItem("Year_id")}`,
        body
    );
};
export const GET_BasicInfo_Bank_info = () => {
    return ApiService.post(
        `/user/get_bankdetails/${localStorage.getItem("Year_id")}`
    );
};
export const GET_FBAR_details = () => {
    return ApiService.post(
        `/user/get_fbardetails/${localStorage.getItem("Year_id")}`
    );
};
export const AddFbar = (body: any) => {
    return ApiService.post(`/user/add_fbar`, body);
};
export const GET_FBAR_details_data = (id: any) => {
    console.log(id.length);
    return ApiService.post(`/user/get_fbar_detail/${id}`);
};
export const GET_FBAR_update = (id: any, body: any) => {
    // console.log(id.length);
    return ApiService.put(
        `/user/update_fbardetails/${id}?tax_file_year_id=${localStorage.getItem(
            "Year_id"
        )}`,
        body
    );
};

//-------------GET OTHER INFO------------
//-------------OTHER INCOME------------

export const GET_Other_income = (type: number) => {
    return ApiService.post(
        `/user/questions_answers/${localStorage.getItem(
            "Year_id"
        )}?question_type=${type}`
    );
};
export const Add_Other_income = (body: any, param: any) => {
    return ApiService.post(
        `/user/save_user_answers/${localStorage.getItem(
            "Year_id"
        )}?type=${param}`,
        body
    );
};

//--------------------Expenses---------------
export const Add_Expenses = (body: any) => {
    return ApiService.post(
        `/user/add_expense/${localStorage.getItem("Year_id")}`,
        body
    );
};
export const Add_Contrubution = (body: any) => {
    return ApiService.post(
        `/user/add_contribution/${localStorage.getItem("Year_id")}`,
        body
    );
};
// ----------------Rental Income-----------------

export const get_Rental_Income = () => {
    return ApiService.post(
        `/user/get_rentalincome/${localStorage.getItem("Year_id")}`
    );
};
export const add_Rental_Income = (body: any) => {
    return ApiService.post(
        `/user/add_rentalincome/${localStorage.getItem("Year_id")}`,
        body
    );
};
// ----------------TAX-SUMMARY----------------

export const Tax_Summary = () => {
    return ApiService.post(
        `/user/get_taxsummary/${localStorage.getItem("Year_id")}`
    );
};

// -------------Change Password -------------
export const change_password = (body: any) => {
    return ApiService.post(`/user/change_password`, body);
};
export const Get_Documents = (type: string) => {
    return ApiService.post(
        `user/get_Documents/${localStorage.getItem(
            "Year_id"
        )}?upload_type=${type}`
    );
};
export const Add_Documents = (data: any) => {
    return ApiService.post(
        `user/save_Documents/${localStorage.getItem(
            "Year_id"
        )}?upload_type=${"user_upload"}`,
        data
    );
};
// ---------------------------Messages----------------------
export const Send_Message = (data: any) => {
    return ApiService.post(
        `user/add_message/${localStorage.getItem("Year_id")}`,
        data
    );
};
export const get_Messages = () => {
    return ApiService.post(
        `user/get_messages/${localStorage.getItem("Year_id")}`
    );
};
export const UpdateStatus = (data: any) => {
    return ApiService.post(
        `user/update_taxstatus/${localStorage.getItem("Year_id")}`,
        data
    );
};
